import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCategoryNavClicked } from 'redux/actions';
import CategoryList from './CategoryList';

function ListViewCategories() {
    const { fetchedData: { categories }, theme: { locale }, cartData: { navClicked } } = useSelector(state => state)
    const dispatch = useDispatch();

    return (
        <div>
            <ul className={`mb-4 menu-tabs d-flex align-items-center pl-0`}>
                {categories?.map((category, index) => {
                    if (category?.products?.length > 0) {
                        return (
                            <li 
                                key={index}
                                id={'id' + index} 
                                className={`menu-tab ${index === 0 ? "active" : ''}`} 
                                onClick={(element) => dispatch(setCategoryNavClicked({element, index}))}
                            >
                                {locale === 'en' ? category?.nameEng : category?.nameAr}
                            </li>
                        )
                    }
                })}
            </ul>

            <div>
                {categories.map((category, index) => {
                    if (category?.products?.length > 0) {
                        return (
                            <section id={"id" + index} className="scrolling-category-block scrolling-category-block-list" key={index}>
                                <CategoryList key={category.category?.id} category={category} locale={locale} />
                            </section>
                        )
                    }
                })}
            </div>
        </div>
    );
}

export default ListViewCategories;